
import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { fetchData, postData } from '../../../apiService';
import { Card, CardContent, TableContainer, Paper, Tooltip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton } from '@mui/material';
import Select from 'react-select';
import DeleteIcon from '@mui/icons-material/Delete';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Modal from '@mui/material/Modal';
import { FaTimes } from 'react-icons/fa';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Link } from 'react-router-dom';
import UndoIcon from '@mui/icons-material/Undo';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import EditIcon from '@mui/icons-material/Edit';

const SaleOrderReturn = () => {
    const { id, tid } = useParams();
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, companyId, userId, token, logout } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
        }
    }, [isAuthenticated, token, logout]);

    const [customerId, setCustomerId] = useState('');
    const [TripId, setTripId] = useState('');
    const [SaleId, setSaleId] = useState('');
    const [qty, setQty] = useState('');
    const [routeOptions, setRouteOptions] = useState([]);
    const [selectedRoute, setSelectedRoute] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [successMessages, setSuccessMessages] = useState("");
    const [errorMessages, setErrorMessages] = useState("");
    const [selectedItem, setSelectedItem] = useState(null);
    const [saleData, setSaleData] = useState([]);
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [invoiceData, setInvoiceData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [quantities, setQuantities] = useState([]);
    const [searchDate, setSearchDate] = useState('');
    const [filteredSaleData, setFilteredSaleData] = useState([]);
    const [highlightedRowIndex, setHighlightedRowIndex] = useState(null);
    const [tableSearchTerm, setTableSearchTerm] = useState('');
    const [filteredSearch, setFilteredSearch] = useState([]);
    const [selectedInvoices, setSelectedInvoices] = useState([]);
    const [lastChangedIndex, setLastChangedIndex] = useState(null);
    const [remark, setRemark] = useState("");
    const [customername, setcustomername] = useState("");
    const [RouteName, setRouteName] = useState('');
    //const [Tripsid, setTripsId] = useState('');
    useEffect(() => {
        fetchTableDataDelivery();
    }, [id, token]);


    const fetchTableDataDelivery = async () => {
        try {
            // Fetch initial delivery sale data
            const initialResponse = await fetchData('ReturnSaleOrderApi', `/${id}`, token);

            if (initialResponse.responseCode === '1111') {
                const deliveryData = initialResponse.response_data;
                setSaleData(deliveryData);
                setCustomerId(deliveryData[0].CustomerId);
                setcustomername(deliveryData[0].CustomerName);
                setRouteName(deliveryData[0].route)
                setTripId(deliveryData[0].TripID);

                console.log(initialResponse);
                // Fetch additional sale data
                const CustomerId = deliveryData[0].CustomerId;

                if (initialResponse) {
                    fetchData('SaleReturnApi', `/${companyId}/${CustomerId}`, token)
                        .then((response) => {
                            if (response.responseCode === '1111') {
                                const sortedData = response.response_data.sort((a, b) => new Date(b.invoiceDate) - new Date(a.invoiceDate));
                                setSaleData(sortedData);
                                setFilteredSaleData(sortedData);
                                setQuantities(new Array(sortedData.length).fill(''));
                                setShowModal(true);
                                //setTripId
                            }
                        })
                        .catch((error) => {
                            console.error('Error fetching invoice details:', error);
                        });
                }


            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };



    const closeModal = () => {
        setShowModal(false);
    };
    const handleInvoiceButton = () => {
        setShowModal(true)
    };

    ///  sale details table { to pic rate, sale rate, saleqty .......}
    const handleInvoiceClick = async (invoice) => {
        try {
            const response = await fetchData('SaleReturnApi', `/SaleReturn/${invoice.id}`, token);
            if (response.responseCode === '1111') {
                const invoiceData = response.response_data;
                setSelectedInvoices(prevSelectedInvoices => {
                    // Check if the invoice is already selected
                    const isSelected = prevSelectedInvoices.some(inv => inv.id === invoice.id);
                    if (isSelected) {
                        // If already selected, remove it from the list
                        return prevSelectedInvoices.filter(inv => inv.id !== invoice.id);
                    } else {
                        // If not selected, add it to the list
                        return [...prevSelectedInvoices, { id: invoice.id, data: invoiceData }];
                    }
                });
            }
        } catch (error) {
            console.error('Error fetching invoice data:', error);
        }
    };

    // Return Qty 
    const handleQuantityChange = (index, newValue) => {
        setLastChangedIndex(index);
        const updatedQuantities = [...quantities];
        updatedQuantities[index] = newValue;
        setQuantities(updatedQuantities);
        setHighlightedRowIndex(index);
    };


    const handleHistoryClick = async (saleid) => {
        try {
            const response = await fetchData('SaleReturnApi', `/SaleReturn/${saleid}`, token);
            if (response.responseCode === '1111') {
                setInvoiceData(response.response_data);
                setShowModal(true);
            }
        } catch (error) {
            console.error('Error fetching Order Items:', error);
        }
    };

    const combinedInvoiceData = selectedInvoices.flatMap(invoice => invoice.data);


    const handleCategoryChange = (selectedOption) => {
        setSelectedCategory(selectedOption);
        // handleCustomerTypeChange(selectedOption);
        setSelectedRoute(selectedOption);
        setCustomerId(selectedOption.value);
        setSelectedItem(null);
    };

    const handleRefreshClick = () => {

        // setToDate(getCurrentDate());
        // fetchData();
        window.location.reload();
    };

    // calculation {gst, taxable values...........}
    function calculateTotalAmount(rateAfterDiscount, gstrate, quantities, bagweight) {
        gstrate = gstrate || 0;
        const totalQty = quantities * bagweight;
        const taxableAmount = rateAfterDiscount * totalQty * 100 / (100 + gstrate);
        const cgstAmount = taxableAmount * gstrate / (2 * 100);
        const sgstAmount = taxableAmount * gstrate / (2 * 100);
        const igstAmount = 0;
        const totalAmount = taxableAmount + cgstAmount + sgstAmount + igstAmount;
        return totalAmount.toFixed(2);
    }

    function calculateGst(rapeperpeice, gstrate, quantities, bagweight) {
        const cgstAmount = calculateCGST(rapeperpeice, gstrate, quantities, bagweight);
        const sgstAmount = calculateSGST(rapeperpeice, gstrate, quantities, bagweight);
        const igstAmount = 0;
        const gst = cgstAmount + sgstAmount + igstAmount;
        return gst.toFixed(2);
    }

    function calculateCGST(rateAfterDiscount, gstrate, quantities, bagweight) {
        gstrate = gstrate || 0;
        const totalQty = quantities * bagweight;
        const taxableAmount = rateAfterDiscount * totalQty * 100 / (100 + gstrate);
        const cgstAmount = taxableAmount * gstrate / (2 * 100);
        const sgstAmount = taxableAmount * gstrate / (2 * 100);
        return cgstAmount;
    }

    function calculateSGST(rateAfterDiscount, gstrate, quantities, bagweight) {
        gstrate = gstrate || 0;
        const totalQty = quantities * bagweight;
        const taxableAmount = rateAfterDiscount * totalQty * 100 / (100 + gstrate);
        const cgstAmount = taxableAmount * gstrate / (2 * 100);
        const sgstAmount = taxableAmount * gstrate / (2 * 100);
        return sgstAmount;
    }

    function taxableAmount(rateAfterDiscount, gstrate, quantities, bagweight) {
        gstrate = gstrate || 0;
        const totalQty = quantities * bagweight;
        const taxableAmount = rateAfterDiscount * totalQty * 100 / (100 + gstrate);
        return taxableAmount.toFixed(2);
    }
    const [newItem, setNewItem] = useState({
        Id: '',
        quantity: 1,
    });

    const [itemList, setItemList] = useState([]);

    const AddtoListdata = (e) => {
        e.preventDefault();
        const updatedItem = { quantity: parseInt(qty) };
        setItemList([...itemList, updatedItem]);
        setNewItem({
            quantity: 1,
        });
        setSelectedItem(null);
        setQty('');
    };

    ///delete
    const [itemToDeleteIndex, setItemToDeleteIndex] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

    const openConfirmDialog = (index) => {
        setItemToDeleteIndex(index);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setConfirmDialogOpen(false);
        setItemToDeleteIndex(null);
    };

    const handleDelete = () => {
        if (itemToDeleteIndex !== null) {
            const updatedItemList = itemList.filter((_, i) => i !== itemToDeleteIndex);
            setItemList(updatedItemList);
            closeConfirmDialog();
        }
    };

    const handleSearch = () => {
        const filteredData = saleData.filter(item => {
            const invoiceDate = new Date(item.invoiceDate).toLocaleDateString('en-GB');
            return invoiceDate.includes(searchDate);
        });
        setFilteredSaleData(filteredData);
    };

    // Modify the submitData function to include only highlighted or non-zero quantities
    const submitData = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        // Create a SaleReturn object with required fields
        const saleReturnData = {
            TripID: parseInt(TripId), // Convert to integer if needed
            CustomerId: customerId,
            ReturnDate: new Date(),
            CreatedBy: userId,
            CompanyId: companyId,
            CreatedDate: new Date(),
            SaleID: SaleId || null, // Provide null if SaleId is empty
            ReturnNo: 0,
            Remark: remark,
            ItemName: combinedInvoiceData.find(item => item.ItemId === SaleId)?.ItemName || 'Unknown',
        };

        // Create an array to hold sale return details
        const saleReturnDetails = [];

        // Iterate through quantities to include only highlighted or non-zero quantities
        quantities.forEach((quantity, index) => {
            if (quantity && quantity > 0) { // Check if quantity is highlighted or greater than 0
                const item = combinedInvoiceData[index];
                saleReturnDetails.push({
                    CustomerId: customerId,
                    CompanyId: companyId,
                    Rate: item.Rate,
                    RQuantity: parseInt(quantity), // Convert to integer if needed
                    CreatedBy: userId,
                    CreatedDate: new Date(),
                    SaleID: item.SaleID,
                    TripID: parseInt(TripId), // Convert to integer if needed
                    SRate: item.TotalAmount,
                    SQuantity: item.Quantity,
                    ItemId: item.ItemId,
                    GSTRate: item.GSTRate,
                    ItemName: item.ItemName,
                    Item: item.ItemName,
                    DiscountAmount: item.DiscountAmount,
                    DiscountPerkg: item.DiscountPerPiece,
                    Bagweight: item.BagWeight,
                    RateperKg: item.RatePerKg,
                    RateAfterDiscount: item.RateAfterDiscount
                });
            }
        });

        // Create data object with saleReturn and saleReturnDetails
        const CreateData = {
            SaleReturn: saleReturnData,
            SaleReturnDetails: saleReturnDetails,
        };

        // Make the POST request to create sale return
        try {
            const response = await postData('SaleReturnApi', CreateData, token);
            console.log('Sale Return success:', response);
            setQuantities(Array(combinedInvoiceData.length).fill("")); // Clear quantities after successful submission
            setSuccessMessages("Sale Return successfully!");
            setErrorMessages("");
            history.push(`/SaleOrderCreate/${id}/${TripId}`);

            setTimeout(() => {
                setSuccessMessages("");
            }, 3000);
        } catch (error) {
            console.error('Sale Return error:', error);
            setIsLoading(false);
            // Handle error here (e.g., display error message to user)
        }
    };

    return (
        <div className="container w-full max-w-sm container mt-2 mx-auto" style={{ maxHeight: '730px', overflow: 'auto', maxWidth: '95%' }}>
            <style>
                {`
            .container::-webkit-scrollbar {
              width: 0.1em;
            }
            .container::-webkit-scrollbar-track {
              background: rgba(255,255,255,0);
            }
            .container::-webkit-scrollbar-thumb {
              background-color: rgba(255,255,255,0);
              border-radius: 4px;
            }
          `}
            </style>

            <div>
                <div className="w-full sm:w-full mb-4 rounded-lg shadow-lg" style={{ backgroundColor: 'rgba(255, 255, 255, 0)' }}>

                    <CardContent>
                        <div>
                            <h4 className="block uppercase text-lg font-semibold mb-4 linkcolor mr-2" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'brown' }}>Sale Return</h4>
                        </div>
                        <div style={{ marginTop : '-48px' , marginLeft : '45%'}}>
                            <h4 className="block uppercase text-lg font-semibold mb-4 linkcolor mr-2" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'brown' }}>Route : {RouteName}</h4>
                        </div>
                        <div className="flex mb-2" style={{ justifyContent: "flex-end" }}>
                            <Link to={`/SaleReturnIndex`}>
                                <Button style={{ background: 'blue', fontWeight: 'bolder', color: 'white' }}>  Edit <EditIcon style={{ fontWeight: 'bolder' }} /></Button>
                            </Link>
                            &nbsp;&nbsp;&nbsp;
                            <Link to={`/SaleOrderCreate/${id}/${TripId}`}>
                                <Button style={{ background: '#FF004F', fontWeight: 'bolder', color: 'white' }}> <UndoIcon style={{ fontWeight: 'bolder' }} />   Cancel</Button>
                            </Link>
                            &nbsp;&nbsp;&nbsp;
                            <Button onClick={handleInvoiceButton} style={{ background: '#BF40BF', fontWeight: 'bolder', color: 'white' }} >
                                <CalendarMonthIcon style={{ fontWeight: 'bolder' }} /> Sale Date</Button>
                            &nbsp;&nbsp;&nbsp;

                            <Button onClick={submitData} style={{ background: '#7FFFD4', color: 'green', fontWeight: 'bolder' }} disabled={isLoading}>
                                {isLoading ? <CircularProgress size={24} color="inherit" /> : "SAVE"} <CheckCircleIcon />
                            </Button>

                        </div>
                        <div className='w-full mb-1' style={{ display: 'flex', flexWrap: 'wrap' }}>
                            <div className="w-full sm:w-full pr-2 mb-2 sm:mb-0">
                                <label className="block tracking-wide text-black text-base font-medium mb-2" htmlFor="customer">
                                    Customer
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={customername}
                                    style={{ width: '40%' }}
                                    name="name"
                                    readOnly
                                />
                            </div>
                            
                            <div className="w-1/2 mr-2" style={{ marginTop : '-77px' , marginLeft : '50%' }}>
                                <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="Branch">
                                    Remark
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={remark}
                                    onChange={(e) => setRemark(e.target.value)}
                                    type="text"
                                    placeholder="Enter Remark"
                                />
                            </div>
                     


                        </div>

                        
                        <div className="w-full mb-4 flex">
                            <TableContainer component={Paper}>
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th style={{ width: '50px' }}>Sl.No</th>
                                            <Tooltip title="Sale Date"><th style={{ width: '50px' }}>S.Date</th></Tooltip>
                                            <Tooltip title="Item Name"><th>Name</th></Tooltip>
                                            <Tooltip title="Rate"><th>Rate<p style={{ fontSize: '10px', marginBlock: '-7px', fontFamily: ' Times New Roman", Times, serif' }}>(per piece)</p></th></Tooltip>
                                            <th>Discount</th>
                                            <Tooltip title="Sale Rate"><th>Rate <p style={{ fontSize: '10px', marginBlock: '-7px', fontFamily: ' Times New Roman", Times, serif' }}>(after discount)</p></th></Tooltip>
                                            <Tooltip title="Sale Quantity"><th style={{ width: '50px' }}>S.Qty</th></Tooltip>
                                            <th>GST %</th>
                                            <Tooltip title="Return Quantity"><th>R.Qty <p style={{ fontSize: '10px', marginBlock: '-7px', fontFamily: ' Times New Roman", Times, serif' }}>(No.of pieces)</p></th></Tooltip>
                                            <Tooltip title="Total Quantity"><th>Total Qty</th></Tooltip>
                                            <Tooltip title="Return Rate"><th>R.Rate</th></Tooltip>
                                            <Tooltip title="Taxable Amount"><th>Taxable Amt</th></Tooltip>
                                            <th>GST</th>
                                            <Tooltip title="Net Amount"><th>Net Amt</th></Tooltip>
                                        </tr>

                                    </thead>

                                    <tbody>
                                        {combinedInvoiceData && combinedInvoiceData.map((item, index) => (
                                            <tr key={index}>
                                                <td className="border-r">{index + 1}</td>
                                                <td className=" border-r"> {item.invoiceDate ? new Date(item.invoiceDate).toLocaleDateString('en-GB') : ''}</td>
                                                <td className="border-r">{item.ItemName}</td>
                                                <td className="px-4 py-2 border-r" style={{ textAlign: 'right' }}>{item.Rate.toFixed(2)}</td>
                                                <td className="px-4 py-2 border-r" style={{ textAlign: 'right' }}>{item.DiscountPerPiece.toFixed(2)}</td>
                                                <td className="px-4 py-2 border-r" style={{ textAlign: 'right' }}>{(item.RateAfterDiscount).toFixed(2)}</td>
                                                <td className=" border-r">{item.Quantity}</td>
                                                <td className="border-r">{item.GSTRate}</td>
                                                <td className="border-r" style={{ padding: '1px', fontSize: '14px', width: '80px', textAlign: 'center' }}>

                                                    <input
                                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                                        style={{ backgroundColor: quantities[index] > 0 ? '#FFD6D1' : 'inherit', width: '80px' }}
                                                        value={quantities[index]}
                                                        onFocus={() => setHighlightedRowIndex(index)}
                                                        onBlur={() => setHighlightedRowIndex(null)}
                                                        onChange={(e) => {
                                                            const input = e.target.value.replace(/\D/g, '');
                                                            if (input.length <= 7) {
                                                                const newQuantity = parseInt(input, 10);
                                                                handleQuantityChange(index, input);
                                                            }
                                                        }}
                                                        type="text"
                                                        min="0"
                                                    />
                                                </td>
                                                <td className="border-r" style={{ textAlign: 'right', width: '100px' }}>{isNaN(item.BagWeight * quantities[index]) ? '0.00' : (item.BagWeight * quantities[index])}</td>
                                                <td className="border-r" style={{ textAlign: 'right', width: '80px' }}>{(item.RateAfterDiscount).toFixed(2)}</td>
                                                <td className="px-4 py-2 border-r" style={{ textAlign: 'right' }}>{isNaN(taxableAmount(item.RateAfterDiscount, item.GSTRate, quantities[index], item.BagWeight)) ? '0.00' : taxableAmount(item.RateAfterDiscount, item.GSTRate, quantities[index], item.BagWeight)}</td>
                                                <td className="border-r" style={{ textAlign: 'right', width: '80px' }}>{calculateGst(item.RateAfterDiscount, item.GSTRate, quantities[index], item.BagWeight)}</td>
                                                <td className="px-4 py-2 border-r" style={{ textAlign: 'right' }}>{isNaN(calculateTotalAmount(item.RateAfterDiscount, item.GSTRate, quantities[index], item.BagWeight)) ? '0.00' : calculateTotalAmount(item.RateAfterDiscount, item.GSTRate, quantities[index], item.BagWeight)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <Dialog
                                    open={confirmDialogOpen}
                                    onClose={closeConfirmDialog}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                >
                                    <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                                    <DialogContent>
                                        <DialogContentText id="alert-dialog-description">
                                            Are you sure you want to delete this record?
                                        </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                        <button
                                            onClick={closeConfirmDialog}
                                            style={{
                                                backgroundColor: '#dc3545',
                                                color: '#ffffff',
                                                border: '1px solid #dc3545',
                                                borderRadius: '4px',
                                                padding: '8px 16px',
                                                cursor: 'pointer',
                                                marginRight: '8px',
                                            }}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            onClick={handleDelete}
                                            style={{
                                                backgroundColor: '#28a745',
                                                color: '#ffffff',
                                                border: '1px solid #28a745',
                                                borderRadius: '4px',
                                                padding: '8px 16px',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            Confirm
                                        </button>
                                    </DialogActions>
                                </Dialog>
                            </TableContainer>
                        </div>
                    </CardContent>
                </div>

                {showModal && (
                    <Modal open={showModal} className={showModal ? 'notification-modal' : ''}>
                        <div className="fixed inset-0 flex items-start justify-center z-10 ">
                            <div className="bg-green-100  p-6 rounded-lg shadow-lg" style={{ width: '700px', maxHeight: '80vh', overflowY: 'auto', overflowX: 'auto' }}>
                                <div className="flex justify-end mt-2">
                                    <button className="close-button md:static md:mr-2" onClick={closeModal} style={{ marginTop: '-20px', color: 'black' }}>
                                        <Tooltip title="Close">
                                            <FaTimes />
                                        </Tooltip>
                                    </button>
                                </div>
                                <Card className="w-full sm:w-1/2 mb-4 rounded-lg shadow-lg" style={{ backgroundColor: 'rgba(255, 255, 255, 0)' }}>
                                    <CardContent>
                                        <div>
                                            <h2 className="text-lg font-bold">{customername}</h2>
                                        </div>
                                        <div className='w-full mb-5' style={{ display: 'flex', flexWrap: 'wrap' }}>
                                            <input
                                                type="text"
                                                placeholder="Search by date (DD/MM/YYYY)"
                                                value={searchDate}
                                                onChange={(e) => {
                                                    setSearchDate(e.target.value);
                                                    handleSearch(e.target.value);
                                                }}
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline mb-2"
                                            />
                                            {filteredSaleData && filteredSaleData.map((item, index) => (
                                                <Card key={index} className="customCard" style={{ marginBottom: '10px', backgroundColor: selectedInvoices.some(inv => inv.id === item.id) ? '#50C878' : '', color: 'white', cursor: 'pointer' }} onClick={() => handleInvoiceClick(item)}>
                                                    <CardContent style={{ height: '40px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                        <a href="#" className="tooltip-link" style={{ color: 'black' }}>
                                                            Date: {item.invoiceDate && new Date(item.invoiceDate).toLocaleDateString('en-GB')}
                                                        </a>

                                                    </CardContent>
                                                </Card>
                                            ))}
                                        </div>
                                    </CardContent>
                                </Card>

                            </div>
                        </div>
                    </Modal>

                )}
            </div>
        </div>
    );
};

export default SaleOrderReturn;
